import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  .ant-input-search {
    max-width: 200px;
  }
`;

export const TourWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;
